import { ItemOffer } from '@dgx-pr-spa/shared/util';
import { getItemOffer } from '@additional-services/store/selectors/item.offer.selector';
import { isProtectionSelected } from '@additional-services/store/selectors/protection.selector';
import { createSelector } from '@ngrx/store';
import { replacementCost } from './replacement.cost.selector';

export const getCostSummary = createSelector(
  [isProtectionSelected, replacementCost, getItemOffer],
  (protection: boolean, cost: number, itemOffer: ItemOffer) => ({
    isProtectionSelected: protection,
    replacementCost: cost,
    monthlyPayment: itemOffer?.subsequentPayment,
  })
);
